import type { AcademyAnnouncementBanner } from '~/generated_types';
import type { AcademyAnnouncementBannerThemeSettings } from '../../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { academyAnnouncementBannerKeysForLearner } from './academyAnnouncementBannerKeyFactory';

type AcademyAnnouncementBannerForLearner = AcademyAnnouncementBanner['LEARNER_CONTENT'];
interface AcademyAnnouncementBannerForLearnerWithTheme extends AcademyAnnouncementBannerForLearner {
  themeSettings: AcademyAnnouncementBannerThemeSettings;
}

export function useGetAcademyAnnouncementBannersForExternalUser(
  { academyId }: { academyId: string },
  queryOptions = {},
) {
  return useQuery<AcademyAnnouncementBannerForLearnerWithTheme[]>({
    queryKey: academyAnnouncementBannerKeysForLearner.academyAnnouncementBanners(academyId),
    queryFn: () => FetchPromise.get('/academy_announcement_banners', { academy_id: academyId }),
    ...queryOptions,
  });
}
